import QRCode from './QRCode'

const zhCN = { QRCode: QRCode.zhCN }
const enUS = { QRCode: QRCode.enUS }
export default { zhCN, enUS }